import React, { forwardRef } from 'react';
import { css } from '@linaria/core';
import { classnames } from '../../utils';
import { RadioButton } from '../../atoms';
import { FormControlWrapper } from './FormControlWrapper';
import { brand, theme } from '@terveystalo/design-system-theme';
const reducedHoverStyles = css `
  &:hover {
    box-shadow: 0 0 0 ${theme.border.width.xxs} ${brand.formControl.color.hover.outline};
  }
  &:active {
    box-shadow: 0 0 0 ${theme.border.width.xs} ${brand.formControl.color.active.outline};
  }
`;
/**
 * Radio button item component for use in forms.
 */
export const RadioButtonItem = forwardRef(function RadioButtonItem(props, ref) {
    const { label, icon, children, className, reduced, grayBackground, ...rest } = props;
    return (React.createElement(FormControlWrapper, { label: label, icon: icon, className: className, disabled: rest.disabled, expanded: rest.checked, grayBackground: grayBackground, inputControl: React.createElement(RadioButton, { className: classnames(reduced && !rest.disabled && reducedHoverStyles), ref: ref, grayBackground: !grayBackground, ...rest }), reduced: reduced }, children));
});


import "../../../css/molecules/FormControlItem/RadioButtonItem.css";
